import { Component } from '@angular/core'
import { Subscription } from 'rxjs'
import { SharedService } from 'src/app/shared/services/shared.service'
import { environment } from 'src/environments/environment'
import { OrderList } from '../../models/order.model'
import { TranslateService } from '@ngx-translate/core'
import { ActivatedRoute, Router } from '@angular/router'
import { OrderStatus } from '../../models/order.enum'
import { StoreService } from '../../services/store.service'
@Component({
	selector: 'app-order-list',
	templateUrl: './order-list.component.html',
	styleUrl: './order-list.component.scss',
})
export class OrderListComponent {
	Subscription = new Subscription()
	activeCountries!: any
	OrderTabs = this.SharedService.returnEnumArray(OrderStatus)
	orderFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },
		orderStatus: 1,
		countryId: 224,
		searchText: '',
	}
	filterCount = 0

	attachmentURL: string = environment.attachmentPath

	ordersList: OrderList[] = []

	totalCount = 0
	pendingCount: number = 0
	cachedFilter: any

	attachmentLink = environment.baseURL
	constructor(
		private SharedService: SharedService,
		public translate: TranslateService,
		private orderService: StoreService
	) {
		this.SharedService.headerTitle.next(`STORE.ORDER_LIST.PAGE_TITLE`)
	}

	ngOnInit(): void {
		const savedFilterState = localStorage.getItem('orderFilter')
		if (savedFilterState) {
			this.orderFilter = JSON.parse(savedFilterState)
			this.cachedFilter = this.orderFilter

			this.filterCount = this.orderFilter.filterCount
		}
		this.getActiveCountries()
		this.SharedService.handleBreadCrumb('Order-List', true, {
			name: '',
			id: '',
			url: '/layout/store/orders',
		})
		this.getOrders()
		this.getNewOrderCount()
	}
	countryChange(countryId: number) {
		this.orderFilter.countryId = countryId
		this.getOrders()
		this.getNewOrderCount()
	}
	getOrders(search = false, filter: any = null) {
		search ? (this.orderFilter.paging.pageNumber = 1) : null
		filter ? (this.orderFilter = { ...this.orderFilter, ...filter }) : null

		this.Subscription.add(
			this.orderService.getOrders(this.orderFilter).subscribe((res: any) => {
				this.ordersList = res.result?.items
				this.totalCount = res?.result?.totalCount

				this.getNewOrderCount()
				this.saveFilterState()
			})
		)
	}
	getNewOrderCount(search = false) {
		let body
		if (this.orderFilter.orderStatus !== '1') {
			body = { ...this.orderFilter }
			body.orderStatus = 1
		} else {
			body = this.orderFilter
		}

		search ? (this.orderFilter.paging.pageNumber = 1) : null
		this.Subscription.add(
			this.orderService.getOrdersNewCount(body).subscribe((res: any) => {
				this.pendingCount = res?.result?.newOrderCount

				let newOrder = this.OrderTabs.find((val) => val.value == '1')

				if (this.pendingCount) {
					newOrder.count = this.pendingCount
					newOrder.showCount = true
				} else {
					newOrder.count = 0
					newOrder.showCount = false
				}
			})
		)
	}
	tapChanged(event: any) {
		this.orderFilter.paging.pageNumber = 1
		this.orderFilter.orderStatus = event
		this.getOrders()
		this.getNewOrderCount()
	}

	searchTextChanged(event: any) {
		this.orderFilter.searchText = event
		if (this.cachedFilter) {
			this.cachedFilter.searchText = event
		}
		this.saveFilterState()
		this.getOrders()
		this.getNewOrderCount()
	}

	pagingChanged(pageNumber: number, pageCount: number) {
		this.orderFilter.paging.pageNumber = pageNumber
		this.orderFilter.paging.pageSize = pageCount
		this.getOrders()
		this.getNewOrderCount()
	}

	getActiveCountries() {
		this.Subscription.add(
			this.SharedService.getActiveCountries().subscribe((res: any) => {
				this.activeCountries = res
			})
		)
	}
	exportOrdersToExcel() {
		let body = this.orderFilter
		delete body.filterCount
		this.Subscription.add(
			this.orderService.exportOrdersToExcel(body).subscribe((res: any) => {
				let downloadLink = this.attachmentLink + res.result
				console.log(downloadLink)

				const link = document.createElement('a')
				link.setAttribute('target', '_blank')
				link.setAttribute('href', downloadLink)
				link.setAttribute('download', `products.csv`)
				document.body.appendChild(link)
				link.click()
				link.remove()
			})
		)
	}
	saveFilterState() {
		this.orderFilter.filterCount = this.filterCount
		localStorage.removeItem('orderFilter')
		localStorage.setItem('orderFilter', JSON.stringify(this.orderFilter))
	}

	ngOnDestroy(): void {
		this.saveFilterState()
		this.Subscription.unsubscribe()
		this.saveFilterState()
	}
}
